<template>
	<div class="flex flex-wrap items-center bg-yellow-100 p-2 text-yellow-600">
		<slot />
	</div>
</template>
